import { render } from "./NoKRsPlaceholder.vue?vue&type=template&id=963071e4&scoped=true"
import script from "./NoKRsPlaceholder.vue?vue&type=script&lang=js"
export * from "./NoKRsPlaceholder.vue?vue&type=script&lang=js"

import "./NoKRsPlaceholder.vue?vue&type=style&index=0&id=963071e4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-963071e4"

export default script